import CustomPdfViewer from './CustomPdfViewer'

export default CustomPdfViewer